import { Field } from "formik";

import { FormFieldWrapper } from "../../../../organisms/form-field-wrapper";
import { FormikFormInputText } from "../../form-input-text";

interface IProps {
  id?: string;
  label?: string;
  placeholder?: string;
}

export const FormFieldLastName: React.FC<IProps> = ({
  id = "lastName",
  label = "Child's last name",
  placeholder = "Enter last name",
}) => (
  <FormFieldWrapper label={label} required name={id}>
    <Field name={id} component={FormikFormInputText} placeholder={placeholder} />
  </FormFieldWrapper>
);
